import apiClient from '../apiClient';

// Statutory Compliance Service
export const statutoryComplianceService = {
  // Get all statutory compliances
  getCompliances: async (params = {}) => {
    try {
      const response = await apiClient.get('/statutory-compliances', { params });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get compliance by ID
  getComplianceById: async (complianceId) => {
    try {
      const response = await apiClient.get(`/statutory-compliances/${complianceId}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Create new statutory compliance
  createCompliance: async (complianceData) => {
    try {
      const response = await apiClient.post('/statutory-compliances', complianceData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Update statutory compliance
  updateCompliance: async (complianceId, complianceData) => {
    try {
      const response = await apiClient.put(`/statutory-compliances/${complianceId}`, complianceData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete statutory compliance
  deleteCompliance: async (complianceId) => {
    try {
      const response = await apiClient.delete(`/statutory-compliances/${complianceId}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Complete compliance task
  completeCompliance: async (complianceId, completionData) => {
    try {
      const response = await apiClient.post(`/statutory-compliances/${complianceId}/complete`, completionData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Calculate compliance for employee
  calculateCompliance: async (complianceId, calculationData) => {
    try {
      const response = await apiClient.post(`/statutory-compliances/${complianceId}/calculate`, calculationData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Export compliances
  exportCompliances: async (params = {}) => {
    try {
      const response = await apiClient.get('/statutory-compliances/export', {
        params,
        responseType: 'blob' // Important for file downloads
      });
      return response.data || response;
    } catch (error) {
      
      throw error;
    }
  },

  // Fetch compliance data for frontend-side export
  fetchExportData: async (params = {}) => {
    try {
      const response = await apiClient.get('/statutory-compliances/export', {
        params: { ...params, format: 'json' }
      });
      return response.data || response;
    } catch (error) {
      
      throw error;
    }
  },

  // Upload a document for a compliance item
  uploadComplianceDocument: async (complianceId, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await apiClient.post(`/statutory-compliances/${complianceId}/documents`, formData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get compliance statistics
  getComplianceStats: async () => {
    try {
      const response = await apiClient.get('/statutory-compliances/stats');
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
};

export default statutoryComplianceService;
